import React, { useState } from "react";
import backgroundImage from "../Assets/skyimage1.png"; // Adjust the path as needed
import part1Image from "../Assets/Questions/mountain.JPG"; // Import the image
import image2 from "../Assets/Questions/2.jpg";
import image3 from "../Assets/Questions/3.jpg";
import image4 from "../Assets/Questions/4.jpg";
import image5 from "../Assets/Questions/5.jpg";
import image6 from "../Assets/Questions/6.jpg";
import image7 from "../Assets/Questions/7.jpg";
import image8 from "../Assets/Questions/8.jpg";
import image9 from "../Assets/Questions/9.jpg";
import image10 from "../Assets/Questions/10.jpg";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const VisitorPage = () => {
  const styles = {
    container: {
      minHeight: "100vh", //fills the viewport but allows content to expand
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
    },
    //CONTAINER FOR NAME, BDAY, CITY, EMAIL
    inputBox1: {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      textAlign: "center",
      width: "30%",
      height: "70%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "20px",
      paddingBottom: "20px",
      paddingLeft: "5px",
      paddingRight: "5px",
      gap: "0px",
    },
    labelInputBox: {
      fontSize: "20px",
      margin: "0px",
      fontWeight: "500",
      flex: "left",
      //alignItems: 'flex-start',
    },
    //INPUT FOR NAME, BDAY, CITY, etc.
    input: {
      width: "80%",
      height: "30%",
      padding: "5px",
      margin: "0px",
      border: "1px solid #ccc",
      borderRadius: "5px",
    },
    startButton: {
      padding: "10px 20px",
      border: "none",
      backgroundColor: "#007BFF",
      color: "#fff",
      borderRadius: "5px",
      cursor: "pointer",
      height: "25%",
      width: "40%",
      marginTop: "15px",
    },
    //CONTAINER FOR Q NUMBER, QUETION, CHOICES
    inputBox2: {
      backgroundColor: "rgba(255, 255, 255, 0.9)", // Semi-transparent white
      paddingTop: "5px",
      paddingBottom: "5px",
      paddingLeft: "15px",
      paddingRight: "15px",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      textAlign: "center",
      width: "50%",
      height: "70%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    button: {
      padding: "10px 20px",
      border: "none",
      backgroundColor: "#007BFF",
      color: "#fff",
      borderRadius: "5px",
      cursor: "pointer",
    },
    choices: {
      listStyleType: "none",
      padding: 0,
      width: "70%",
      margin: "20px",
    },
    choiceItem: {
      margin: "10px 0",
    },
    choiceButton: {
      padding: "10px",
      border: "1px solid rgba(133, 104, 255, 0.9)",
      backgroundColor: "#fff",
      color: "white",
      borderRadius: "5px",
      cursor: "pointer",
      width: "100%",
      backgroundColor: "rgba(133, 104, 255, 0.9)",
      marginTop: "10px",
    },
    formGroup: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "10px",
    },
    checkboxGroup: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
  };

  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [answers, setAnswers] = useState({});
  const [birthDate, setBirthDate] = useState();
  const [birthTime, setBirthTime] = useState();
  const [dontKnowTime, setDontKnowTime] = useState();
  const [city, setCity] = useState();
  const [email, setEmail] = useState();
  const [sendUpdates, setSendUpdates] = useState();
  const [results, setResults] = useState(0); // Initialize total score
  const [resultDesc, setResultDesc] = useState(""); // Store the first answer
  const [finalResult, setFinalResult] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [apiResult, setApiResult] = useState([]);
  const [STEM_RELATION, setSTEM_RELATION] = useState(""); // Track STEM_RELATION
  const [label, setLabel] = useState("");
  const [imageResult, setImageResult] = useState();

  const formatDateTimeSQL = (date, time) => {
    return time && !dontKnowTime ? `${date} ${time}:00` : `${date} 00:00:00`;
  };

  const Postvisitor = async () => {
    const url = "https://your-api-endpoint.com"; // Replace with actual API endpoint

    const data = {
      NAME: name,
      DOB: formatDateTimeSQL(birthDate, birthTime),
      EMAIL: email,
      CITY: city,
      RESULTS: results, // Total score
      RESULTS_DESC: resultDesc, // First question's answer
      UPDATE_BY: "ADMIN",
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Success:", result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const resultMappings = [
    {
      title: "The Mountain",
      stem: "Mountain  ",
      image: part1Image,
      strength: "Creative, idealistic, and introspective.",
      weakness: "Sometimes detached from reality and overly sensitive.",
      summary:
        "You have a deep inner world and a vivid imagination.\nYou thrive in environments that allow for self-expression and creativity.",
    },
    {
      title: "The Soil",
      stem: "Soil      ",
      image: image2,
      strength:
        "As grounded as a lump of soil on the ground.\nAccommodating peacemaker",
      weakness:
        "Overly cautious and doubtful lives in a cave, unaware of trends",
      summary:
        "Can The Soil get his head out of the ground?\n- The Star\nHard on the outside, but soft on the inside, am I talking about an egg or The Soil?\n- The Axe",
    },
    {
      title: "The Sun",
      stem: "Sun       ",
      image: image3,
      strength:
        "You shine as bright as...the Sun. Of course.\nYou are a shining source of fun and adventures",
      weakness:
        "Your temper is as explosive as the sun is hot.\nMay be confrontational",
      summary:
        "Wow is he always on fire!\n- The Tree\nHave I told you how hot you are today? Oh? I said it three times already? But The Sun is hot.\n- The Flower",
    },
    {
      title: "The Star",
      stem: "Star      ",
      image: image4,
      strength:
        "You are a superstar, a money star, good with numbers\nConfident and driven",
      weakness: "Competitive risk-taker\nMay be unstable and anxious",
      summary:
        "Is that a bird, is that a plane, that’s a shooting star!\n- The Soil\nStop blinking, twinkling so much so I can see you clearly!\n- The Sun",
    },
    {
      title: "The Axe",
      stem: "Axe       ",
      image: image5,
      strength: "Decisive, chop chop gotta go.\nHonest and analytical",
      weakness:
        "Unwilling to bury the hatchet.\nHeart and logic as cold as steel.",
      summary:
        "He chops challenges like he chops my wood!\n- The Tree\nHe always looks like he has an axe to grind.\n- The Mountain",
    },
    {
      title: "The Knife",
      image: image6,
      stem: "Knife     ",
      strength: "Sharpest knife in the kitchen!\nCuts straight to the point",
      weakness: "Can be very direct.",
      summary:
        "They say metal reflects light, but really, he deflects my point\n- The Sun",
    },
    {
      title: "The Tree",
      image: image7,
      stem: "Large Tree",
      strength: "You provide shelter to all who come to you.\nYou don’t judge.",
      weakness:
        "You are stubbornly rooted.\nYou can’t see the forest for the trees.",
      summary:
        "The Tree is so tall and inspiring! Yet speaks so gentle and soothing\n- The Flower\nWhy are they so greedy for my sunlight?\n- The Sun",
    },
    {
      title: "The Flower",
      image: image8,
      stem: "Flowers   ",
      strength: "You are caring and helpful\nYou are nurturing and empathetic",
      weakness:
        "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary:
        "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Ocean",
      stem: "Ocean     ",
      image: image9,
      strength: "Something good about rain clouds here.",
      weakness:
        "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary:
        "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Rain Cloud",
      stem: "Cloud     ",
      image: image10,
      strength: "Something good about rain clouds here.",
      weakness:
        "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary:
        "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
  ];

  const handleNext = () => {
    if (step === 1 && name.trim() === "") {
      alert("Please enter your name!");
      return;
    } else if (!birthDate || !birthTime) {
      alert("Please enter birth date and birth time!");
      return;
    }

    setStep(step + 1);
  };

  const handleChoice = (label) => {
    const categoryMap = {
      Money: "WEALTH",
      Wisdom: "WISDOM",
      Love: "RS",
      Health: "HEALTH",
    };

    setLabel(label);

    if (!STEM_RELATION) {
      console.error("STEM_RELATION is not set or is empty!");
      return; // Exit the function early if STEM_RELATION is invalid
    }

    const stemRelation = STEM_RELATION.trim();
    console.log("Trimmed STEM_RELATION:", stemRelation); // Log the trimmed STEM_RELATION

    // Find the result that matches the stemRelation
    const result = resultMappings.find(
      (item) => item.stem.trim() === stemRelation // Match using the stem field
    );

    console.log(
      "Available Stems in resultMappings:",
      resultMappings.map((item) => item.stem.trim())
    ); // Log all stems
    console.log("Matched Result:", result); // Log the matched result

    // Set the final result based on the match
    setFinalResult(result || resultMappings[0]); // Fallback to the first result if no match found
    setStep(3); // Move to the final result step
  };

  const tryFetchChineseDOB = (selectedDate, selectedTime, isUnknownTime) => {
    if (selectedDate && (selectedTime || isUnknownTime)) {
      const timeToUse = isUnknownTime ? "00:00" : selectedTime;
      fetchChineseDOB(new Date(selectedDate), timeToUse);
    }
  };

  // Separate function to handle the first API request (Chinese DOB)
  const fetchChineseDOB = (date, timeString) => {
    const cYear = date.getFullYear();
    const cMonth = (date.getMonth() + 1).toString().padStart(2, "0");
    const cDay = date.getDate().toString().padStart(2, "0");
    const cTime = timeString || "00:00"; // fallback to 00:00 if no time

    const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${cTime}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log("Chinese DOB API Response:", data);
        if (data && data.length > 0) {
          // fetchLunarHeavenlyStems(data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Chinese DOB:", error);
      });
  };

  // const fetchLunarHeavenlyStems = (dobData) => {
  //   const cYear = dobData.CN_LUNAR_YEAR_NO;
  //   const cMonth = dobData.CN_LUNAR_MONTH_NO;
  //   const cDay = dobData.CN_LUNAR_DAY_NO;
  //   const cTime = "08:30";

  //   const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${cTime}`;

  //   fetch(url)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log("Natal Daily Forecast API Response:", data);

  //       if (Array.isArray(data) && data.length > 0) {
  //         const firstItem = data[0];
  //         const relation = firstItem.STEM_RELATION?.trim(); // Trim whitespace

  //         setApiResult(firstItem);
  //         setSTEM_RELATION(relation);

  //         // Find the matching result mapping
  //         const matchedResult = resultMappings.find(
  //           (entry) => entry.stem.trim() === relation
  //         );

  //         if (matchedResult) {
  //           setImageResult(matchedResult.image);
  //         } else {
  //           console.warn("No matching result found for:", relation);
  //         }
  //       } else {
  //         console.error("Invalid or empty response data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching Natal Daily Forecast:", error);
  //     });
  // };

  const fetchLunarHeavenlyStems = () => {
    const datePart = new Date(birthDate);
    const [hours, minutes] = (birthTime || "00:00").split(":");

    const cYear = datePart.getFullYear();
    const cMonth = datePart.getMonth() + 1;
    const cDay = datePart.getDate();
    const cTime = `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;

    const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${cYear}&cMonth=${cMonth}&cDay=${cDay}&cTime=${cTime}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log("Lunar API response:", data);
        if (Array.isArray(data) && data.length > 0) {
          const firstItem = data[0];
          const relation = firstItem.STEM_RELATION?.trim(); // Trim whitespace

          setApiResult(firstItem);
          setSTEM_RELATION(relation);

          // Find the matching result mapping
          const matchedResult = resultMappings.find(
            (entry) => entry.stem.trim() === relation
          );

          if (matchedResult) {
            setImageResult(matchedResult.image);
          } else {
            console.warn("No matching result found for:", relation);
          }
        } else {
          console.error("Invalid or empty response data");
        }
      })
      .catch((error) => {
        console.error("Error fetching Lunar Heavenly Stems:", error);
      });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {step === 1 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            maxWidth: "400px",
            margin: "0 auto",
            padding: "20px",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div style={styles.formGroup}>
            <label>My Name is:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label>I was born on:</label>
            <DatePicker
              selected={birthDate ? new Date(birthDate) : null}
              onChange={(date) => {
                const localDate = date.toLocaleDateString("en-CA"); // ✅ Use local date
                setBirthDate(localDate);
                tryFetchChineseDOB(localDate, birthTime, dontKnowTime);
                fetchLunarHeavenlyStems(localDate);
              }}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select date"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              showPopperArrow={false}
              maxDate={new Date()}
              filterDate={(date) => date <= new Date()}
              style={styles.dateFormat}
            />
          </div>

          <div style={styles.formGroup}>
            <label>At Birth time:</label>
            <input
              type="time"
              value={birthTime}
              onChange={(e) => {
                const time = e.target.value;
                setBirthTime(time);
                tryFetchChineseDOB(birthDate, time, dontKnowTime);
                fetchLunarHeavenlyStems(birthDate);
              }}
              disabled={dontKnowTime}
            />
          </div>

          <div style={styles.checkboxGroup}>
            <input
              type="checkbox"
              checked={dontKnowTime}
              onChange={(e) => {
                const checked = e.target.checked;
                setDontKnowTime(checked);
                tryFetchChineseDOB(birthDate, birthTime, checked);
                fetchLunarHeavenlyStems(birthDate);
                setBirthTime("00:00");
              }}
            />
            <label>I don’t know my birth time</label>
          </div>

          <div style={styles.formGroup}>
            <label>In:</label>
            <select value={city} onChange={(e) => setCity(e.target.value)}>
              <option value="">Select your city</option>
              <option value="New York">New York</option>
              <option value="London">London</option>
              <option value="Tokyo">Tokyo</option>
              <option value="Sydney">Sydney</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label>My email is:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div style={styles.checkboxGroup}>
            <input
              type="checkbox"
              checked={sendUpdates}
              onChange={(e) => setSendUpdates(e.target.checked)}
            />
            <label>Send me feng shui updates</label>
          </div>

          <button style={styles.button} onClick={handleNext}>
            Start the test
          </button>
        </div>
      )}

      {step === 2 && (
        <div style={styles.inputBox2}>
          <h1>Question 1:</h1>
          <p style={{ fontSize: "20px" }}>
            You encounter a fairy and she offers you four cards of Fate to
            choose from:
          </p>
          <img
            src={imageResult}
            alt="q1pic"
            style={{ width: "200px", height: "auto" }}
          />
          <ul style={styles.choices}>
            <button
              style={styles.choiceButton}
              onClick={() => handleChoice("Money")}
            >
              Money
            </button>
            <button
              style={styles.choiceButton}
              onClick={() => handleChoice("Wisdom")}
            >
              Wisdom
            </button>
            <button
              style={styles.choiceButton}
              onClick={() => handleChoice("Love")}
            >
              Love
            </button>
            <button
              style={styles.choiceButton}
              onClick={() => handleChoice("Health")}
            >
              Health
            </button>
          </ul>
        </div>
      )}

      {step === 3 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            padding: "24px",
            maxWidth: "600px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#8b5cf6",
              color: "white",
              padding: "16px",
              width: "100%",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            Congratulations, you are:
            <br />
            <span style={{ fontSize: "24px", fontWeight: "700" }}>
              {
                resultMappings.find(
                  (r) => r.stem.trim() === STEM_RELATION.trim()
                )?.title
              }
            </span>
          </div>

          {/* Image and Text */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              gap: "20px",
              padding: "24px 0",
            }}
          >
            <img
              src={
                resultMappings.find(
                  (r) => r.stem.trim() === STEM_RELATION.trim()
                )?.image
              }
              alt="Result"
              style={{
                width: "200px",
                height: "100%", // Fill the same height as the text box
                objectFit: "contain",
                borderRadius: "12px",
                backgroundColor: "#f3f4f6", // Optional: visual padding or contrast
                padding: "10px",
              }}
            />

            <div
              style={{
                backgroundColor: "#c084fc",
                color: "white",
                borderRadius: "10px",
                padding: "16px",
                flex: 1, // Take up remaining space
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                Strengths
              </div>
              <div style={{ fontSize: "14px" }}>
                {
                  resultMappings.find(
                    (r) => r.stem.trim() === STEM_RELATION.trim()
                  )?.strength
                }
              </div>

              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginTop: "16px",
                  marginBottom: "8px",
                }}
              >
                Weaknesses
              </div>
              <div style={{ fontSize: "14px" }}>
                {
                  resultMappings.find(
                    (r) => r.stem.trim() === STEM_RELATION.trim()
                  )?.weakness
                }
              </div>
            </div>
          </div>

          {/* Summary / Footer */}
          <div
            style={{
              backgroundColor: "#a78bfa",
              color: "white",
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px",
              padding: "20px",
              fontSize: "14px",
              width: "100%",
            }}
          >
            <div
              style={{
                fontWeight: "600",
                fontSize: "16px",
                marginBottom: "12px",
              }}
            >
              What your friends may say about you:
            </div>
            <div style={{ fontStyle: "italic" }}>
              {
                resultMappings.find(
                  (r) => r.stem.trim() === STEM_RELATION.trim()
                )?.summary
              }
            </div>

            <div style={{ marginTop: "16px" }}>
              <p style={{ marginTop: "12px" }}>Would you like to know more?</p>
              <p>Share with your friends!</p>
              <p>Find out more by booking a consultation!</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisitorPage;
